import React from "react"

function IconMicrophoneWave({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="microphone-wave"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-microphone-wave"
      {...props}
    >
      <path
        d="M18.515 10.581c.362 0 .655.293.655.655a7.147 7.147 0 0 1-6.492 7.117v2.709a.655.655 0 0 1-1.3.106l-.01-.106v-2.71a7.147 7.147 0 0 1-6.491-7.116.655.655 0 1 1 1.309 0 5.837 5.837 0 1 0 11.675 0c0-.362.293-.655.654-.655zm-6.46-8.072a3.655 3.655 0 0 1 3.654 3.655V11.4a3.655 3.655 0 1 1-7.309 0V6.164a3.655 3.655 0 0 1 3.655-3.655zm0 1.31c-1.24 0-2.254.96-2.34 2.177l-.006.168V11.4a2.345 2.345 0 0 0 4.685.168l.006-.168V6.164a2.345 2.345 0 0 0-2.345-2.346zm9.786-2.074a6.2 6.2 0 0 1 1.144 3.622A6.197 6.197 0 0 1 21.84 8.99a.655.655 0 0 1-1.063-.765c.576-.801.898-1.8.898-2.858a4.89 4.89 0 0 0-.898-2.857.655.655 0 1 1 1.063-.765zM19.159 3.23c.477.593.746 1.344.746 2.137 0 .795-.269 1.546-.747 2.138a.655.655 0 1 1-1.018-.822c.29-.36.456-.822.456-1.316 0-.492-.166-.955-.457-1.316a.655.655 0 0 1 1.02-.821z"
        fill={color}
        fillRule="nonzero"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconMicrophoneWave
